import { DiscountCodeScreen } from "./discount-code.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const DiscountCodeRoutes: RouteDefinition[] = [
	{
		path: Paths.activeDiscountActions.withIdPlaceholder().edit.discountCode.withIdPlaceholder()
			.path,
		element: <DiscountCodeScreen />,
		requiredPermissions: ["UserInAccountPermission_DiscountAdmin_Read"],
	},
];
